import { CATEGORIES } from "../../font-awesome-icon/src";
export const SUPPORTED_ICONS = Object.freeze({
    angellist: {
        iconName: 'angellist',
        iconType: CATEGORIES.BRANDS,
        key: 'angellist',
    },
    blackberry: {
        iconName: 'blackberry',
        iconType: CATEGORIES.BRANDS,
        key: 'blackberry',
    },
    facebook: {
        iconName: 'facebook-f',
        iconType: CATEGORIES.BRANDS,
        key: 'facebook',
    },
    flickr: {
        iconName: 'flickr',
        iconType: CATEGORIES.BRANDS,
        key: 'flickr',
    },
    globe: {
        iconName: 'globe',
        iconType: CATEGORIES.REGULAR,
        key: 'globe',
    },
    instagram: {
        iconName: 'instagram',
        iconType: CATEGORIES.BRANDS,
        key: 'instagram',
    },
    linkedin: {
        iconName: 'linkedin-in',
        iconType: CATEGORIES.BRANDS,
        key: 'linkedin',
    },
    pinterest: {
        iconName: 'pinterest',
        iconType: CATEGORIES.BRANDS,
        key: 'pinterest',
    },
    rssfeed: {
        iconName: 'rss',
        iconType: CATEGORIES.REGULAR,
        key: 'rssfeed',
    },
    skype: {
        iconName: 'skype',
        iconType: CATEGORIES.BRANDS,
        key: 'skype',
    },
    twitter: {
        iconName: 'x-twitter',
        iconType: CATEGORIES.BRANDS,
        key: 'twitter',
    },
    viadeo: {
        iconName: 'viadeo',
        iconType: CATEGORIES.BRANDS,
        key: 'viadeo',
    },
    xing: {
        iconName: 'xing',
        iconType: CATEGORIES.BRANDS,
        key: 'xing',
    },
    youtube: {
        iconName: 'youtube',
        iconType: CATEGORIES.BRANDS,
        key: 'youtube',
    },
});
//# sourceMappingURL=utils.js.map